import React from 'react';

/**
 * Skeleton para los gráficos "ROAS por Plataforma" y "Distribución de Inversión" en Analytics.
 * Mantiene el mismo layout: 2 cards en grid con título, línea decorativa y área de gráfico.
 */
const RoasDistributionChartsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mt-8 sm:mt-12 mb-8 sm:mb-12">
      {/* ROAS Bar Chart Skeleton */}
      <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-4 sm:p-6 shadow-lg transition-all duration-500 ease-out">
        <div className="relative z-10">
          <div className="text-center mb-6">
            <div className="h-6 w-40 bg-white/20 rounded animate-pulse mx-auto mb-2" />
            <div className="w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mx-auto" />
          </div>
          <div className="h-[300px] flex items-end justify-center gap-8 px-4">
            <div className="flex flex-col items-center gap-2">
              <div className="w-20 h-24 bg-white/20 rounded-t animate-pulse" style={{ animationDelay: '0ms' }} />
              <div className="h-4 w-20 bg-white/20 rounded animate-pulse" />
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-20 h-16 bg-white/20 rounded-t animate-pulse" style={{ animationDelay: '100ms' }} />
              <div className="h-4 w-16 bg-white/20 rounded animate-pulse" />
            </div>
          </div>
        </div>
      </div>

      {/* Pie Chart / Distribución Skeleton */}
      <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-4 sm:p-6 shadow-lg transition-all duration-500 ease-out">
        <div className="relative z-10">
          <div className="text-center mb-6">
            <div className="h-6 w-48 bg-white/20 rounded animate-pulse mx-auto mb-2" />
            <div className="w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mx-auto" />
          </div>
          <div className="h-[300px] flex items-center justify-center">
            <div className="w-48 h-48 rounded-full bg-white/10 animate-pulse flex items-center justify-center">
              <div className="w-24 h-24 rounded-full bg-slate-800/90" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoasDistributionChartsSkeleton;
